import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
import { Button } from '#app/components/ui/button'

export const meta: MetaFunction = () => [{ title: 'Contact Us | Oui Chef' }]

export default function Contact() {
  return (
    <div className="">
      <div className="mx-auto max-w-3xl px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">Contact Us</h1>
          
          <div className="mt-10 bg-white rounded-xl shadow-sm border border-gray-200 p-8 sm:p-10 max-w-2xl mx-auto">
            <p className="text-lg text-gray-600 mb-6">
              For any inquiries, support requests, or to learn more about our services, please email us at:
            </p>
            
            <div className="my-8 flex justify-center">
              <a 
                href="mailto:sean@ouiwiwe.com" 
                className="text-xl font-semibold text-primary hover:underline"
              >
                sean@ouiwiwe.com
              </a>
            </div>
            
            <p className="text-gray-600 mb-6">
              We'll get back to you as soon as possible, typically within 24 business hours.
            </p>
            
            <div className="mt-8 flex justify-center">
              <Button asChild variant="outline">
                <Link to="/">Return to Home</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 